/**
 * Address suggest: Google Places on international, DaData on Chargex.
 * REACT_APP_RUNTIME=international drops DaData from the webpack bundle.
 */
import * as React from 'react';
import TextField from '@mui/material/TextField';
import AddressPlacesField from './AddressPlacesField';
import AddressDaDataField from './AddressDaDataField';
import { loadAdminRuntime } from '../utils/adminRuntime';

export default function AddressSuggestField(props) {
  const compileTimeInternational = process.env.REACT_APP_RUNTIME === 'international';
  const [places, setPlaces] = React.useState(compileTimeInternational ? 'google' : null);

  React.useEffect(() => {
    if (compileTimeInternational) {
      return undefined;
    }
    let cancelled = false;
    loadAdminRuntime().then((runtime) => {
      if (!cancelled) {
        setPlaces(runtime?.places === 'google' ? 'google' : 'dadata');
      }
    });
    return () => {
      cancelled = true;
    };
  }, [compileTimeInternational]);

  if (compileTimeInternational || places === 'google') {
    return <AddressPlacesField {...props} />;
  }
  if (places == null) {
    return (
      <TextField
        fullWidth
        label={props.label}
        placeholder={props.placeholder ?? props.label}
        value={props.value ?? ''}
        onChange={(e) => props.onChange && props.onChange(e.target.value)}
        error={!!props.error}
        helperText={props.helperText ?? ' '}
        disabled
      />
    );
  }
  return <AddressDaDataField {...props} />;
}
